import { Grid } from '@mui/material';
import { get } from 'lodash-es';
import React, { useEffect } from 'react';

import ContractSkeleton from '../components/Contracts/ContractSkeleton';
import FocusedContract from '../components/Contracts/FocusedContract';
import { useContractConfigurationContext } from '../hooks/useContractConfigurationContext';
import { ContractStep } from './ContractPage';

function NewContractPage() {
  const contractConfigurationContext = useContractConfigurationContext();
  const isLoading = get(contractConfigurationContext, 'isLoading');

  const setContractName = get(contractConfigurationContext, 'setContractName');
  useEffect(() => {
    if (setContractName) {
      setContractName('New Contract');
    }
  }, [setContractName]);

  if (isLoading) {
    return (
      <Grid container>
        <Grid item xs={12}>
          <ContractSkeleton />
        </Grid>
      </Grid>
    );
  }

  return <FocusedContract activeStep={ContractStep.Details} />;
}

export default NewContractPage;
